import { CountryCode } from './geo';

export enum AddressType {
  Mailing = 'Mailing',
  Billing = 'Billing',
  Physical = 'Physical',
}

export enum AddressFieldsEnum {
  Address = 'address',
  Address2 = 'address2',
  City = 'city',
  Country = 'country',
  Postal = 'postal',
  State = 'state',
}

export type Address = {
  type: AddressType;
  [AddressFieldsEnum.Address]: string;
  [AddressFieldsEnum.Address2]?: string;
  [AddressFieldsEnum.City]: string;
  [AddressFieldsEnum.Country]: CountryCode;
  [AddressFieldsEnum.Postal]: string;
  [AddressFieldsEnum.State]: string;
};

export enum MailingAddressEnum {
  Address = 'mailingAddress',
  Address2 = 'mailingAddress2',
  City = 'mailingCity',
  Country = 'mailingCountry',
  Postal = 'mailingPostal',
  State = 'mailingState',
}

export type MailingAddress = {
  [key in MailingAddressEnum]: string;
};

export enum BillingAddressEnum {
  Address = 'billingAddress',
  Address2 = 'billingAddress2',
  City = 'billingCity',
  Country = 'billingCountry',
  Postal = 'billingPostal',
  State = 'billingState',
}

export type BillingAddress = {
  [key in BillingAddressEnum]: string;
};

export interface UniqueAddressValue {
  text: string;
  type: string;
  billingAddress: BillingAddress;
}

export type UniqueAddressMap = Map<string, UniqueAddressValue>;

export enum AddressSelectOptions {
  Add = 'add',
}
